<p-dialog
  [modal]="true"
  [(visible)]="visible"
  (onHide)="onHideDialog()"
  [style]="{ width: '50rem', height: '40rem', borderRadius: '1rem' }"
  [closable]="true"

>
  @if (view === 'list') {
  <app-list
    [addresses]="addresses"
    (selectAddress)="onAddressSelected($event)"
    (add)="openAdd()"
    (edit)="openEdit($event)"
    (delete)="onDelete($event)"
  ></app-list>
  <div class="flex justify-end">
    <p-button
      severity="secondary"
      [label]="'cancel' | translate"
      (click)="visible = false"
    />
  </div>

  } @if (view === 'stepper') {
  <h1 class="text-2xl font-bold mb-4">
    {{
      mode === 'add'
        ? ('addNewAddress' | translate)
        : ('updateAddressInfo' | translate)
    }}
  </h1>

  <p-stepper [value]="1">
    <p-step-list>
      <p-step [value]="0"></p-step>
      <p-step [value]="1"></p-step>
      <p-step [value]="2"></p-step>
    </p-step-list>

    <p-step-panels>
      <p-step-panel [value]="1">
        <ng-template #content let-activateCallback="activateCallback">
          <p
            class="font-bold mb-2 border-b text-xl pb-2 text-[var(--navbar-light-coler)]"
          >
            {{
              mode === 'add'
                ? ('enterAddressDetails' | translate)
                : ('updateAddressDetails' | translate)
            }}
          </p>
          <app-add-update
            [initialData]="formData"
            (formSubmit)="onFormSubmit($event); activateCallback(2)"
          ></app-add-update>
        </ng-template>
      </p-step-panel>

      <p-step-panel [value]="2">
        <ng-template #content let-activateCallback="activateCallback">
          <div class="flex iconright border-b text-xl pb-2">
            <p-button
              severity="secondary"
              icon="pi pi-arrow-left"
              (onClick)="activateCallback(1)"
            />

            <p class="font-bold mb-2 ps-2 text-[var(--navbar-light-coler)]">
              {{ 'findYourLocation' | translate }}
            </p>
          </div>

          <div class="flex flex-auto justify-center my-5">
            <app-map (locationChange)="onLocationChange($event)"></app-map>
          </div>

          <button
            class="w-full mt-4 bg-[var(--navbar-light-coler)] text-white py-3 rounded-2xl"
            (click)="submitAddress()"
          >
            {{ 'addAddress' | translate }}
          </button>
        </ng-template>
      </p-step-panel>
    </p-step-panels>
  </p-stepper>
  }

  <app-confirm
    [(visible)]="showConfirm"
    [cancel]="'cancel' | translate"
    [delete]="'delete' | translate"
    [message]="'areYouSureDeleteAddress' | translate"
    [paragraph]="'deleteAddressWarning' | translate"
    (confirmed)="confirmDelete()"
  ></app-confirm>
</p-dialog>
